import React from "react";
import { styleCondition } from "../inputsAlgorithms";
const Button = ({
  content,
  containerStyle,
  inputStyle,
  type,
  onClick,
  RTL,
  disable,
  height,
  width,
  customStyle,
  buttonStyleType,
  borderWidth,
  styleClass,
  form,
  id,
  image,
}) => {
  const style = disable
    ? "disableBTN"
    : String(buttonStyleType).toLowerCase() === "solid"
      ? "solid"
      : "outline";
  return (
    <>
      <div className={` col-1 ${containerStyle}`}>
        <button
          id={id}
          form={form}
          dir={RTL ?? "rtl"}
          title={content}
          className={`${inputStyle} custom_btn ${style} ${styleClass}`}
          type={type ?? "button"}
          onClick={onClick}
          disabled={disable ?? false}
          style={{
            minWidth: styleCondition(width, 100, "%"),
            height: height ?? 55,
            borderWidth: styleCondition(borderWidth, 1, "px"),
            ...customStyle,
          }}
        >
          <div className="d-flex align-items-center justify-content-center">
            {image ?? null}
            <p className={`mb-0 ${image ? "mx-2" : ""}`}>{content}</p>
          </div>
        </button>
      </div>
    </>
  );
};

export default Button;
